import React, { Component } from 'react';
import { connect } from 'react-redux';
import Currency from 'react-currency-formatter';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Barcode from 'react-barcode';
import moment from 'moment';

import PixCode from 'newComponents/PixCode';
import CustomToolip from './CustomToolip';

import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  CustomerInfoContainer,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  DetailsContainer,
  SectionTitle,
  Link,
  InvoiceNumber,
  DetailsContent,
  StatusContainer,
  StatusIcon,
  BankSlipContainer,
  TypeableLineContainer,
  ToolTipText,
  TypeableLineIcon,
  ToolTipButton,
  BarcodeContainer,
  BarcodeContent,
  BarcodeResponsive,
  BarcodeFullWidth,
  PixSyncIcon,
  RemoveSpace,
  StatusText,
  PaymentWrap,
  PaymentInfos,
  InfoTextPix,
  ReactTooltipPix,
  UpdatePixContainer,
  MobileInfoTooltipWrap,
  MobileInfoTooltipContainer,
  MobileInfoTooltipTitle,
  MobileInfoTooltipText,
} from './styles';
import type {
  BankSlipModalProps,
  BankSlipModalState,
  ModalInstallment,
  ModalStatus,
  QrCodeData,
} from './types';

const getInitialState = (): BankSlipModalState => ({
  copyId: null,
  copyPixId: null,
  customer: {},
  invoice: { invoiceId: '' },
  installment: { installmentId: '', dueDate: '' },
  loading: false,
  status: null,
  qrCodeDataState: null,
});

class BankSlipModal extends Component<BankSlipModalProps, BankSlipModalState> {
  constructor(props: BankSlipModalProps) {
    super(props);
    this.state = getInitialState();
  }

  componentDidMount(): void {
    const { payment, installment } = this.props;
    const { qrcodeData } = installment;

    if (qrcodeData) {
      let cleanQrcodeData = qrcodeData.trim();
      cleanQrcodeData = cleanQrcodeData.replace('"dados_qrcode" : ', '');

      try {
        const parsedData = JSON.parse(cleanQrcodeData) as QrCodeData;
        this.setState({ qrCodeDataState: parsedData });
      } catch (error) {
        console.error('Erro ao analisar o JSON:', error);
      }
    }

    this.organizeData(payment, installment);
    this.handleStatus(installment);
  }

  componentDidUpdate(prevProps: BankSlipModalProps): void {
    const { installment } = this.props;

    if (prevProps.installment?.status !== installment?.status) {
      this.handleStatus(installment);
    }
  }

  organizeData = (
    payment: BankSlipModalProps['payment'],
    installment: ModalInstallment
  ): void => {
    this.setState({ loading: true });

    const { customer = {}, ...invoiceData } = payment;

    this.setState({
      invoice: invoiceData,
      customer,
      installment,
      loading: false,
    });
  };

  convertLine = (dados?: string): string => {
    const line = `${dados ?? ''}`;
    const bank = line.substring(0, 3);
    const coin = line.substring(3, 4);
    const camp = line.substring(4, 9);
    const camp2 = line.substring(10, 20);
    const camp4 = line.substring(21, 31);
    const camp6 = line.substring(32, 47);

    return bank + coin + camp6 + camp + camp2 + camp4;
  };

  handleStatus = (installment: ModalInstallment): void => {
    const currentDate = new Date();
    const dueDate = new Date(installment.dueDate);
    dueDate.setDate(dueDate.getDate() + 1);

    let status: ModalStatus = 'Pago';

    if (installment.paymentStatus === 'OP') {
      status = currentDate > dueDate ? 'Vencido' : 'A vencer';
    }

    this.setState({ status });
  };

  handleCopyToClickBoard = (copyId: string): void => {
    this.setState({
      copyId,
      copyPixId: null,
    });
  };

  handleCopyPixToClickBoard = (copyPixId: string): void => {
    this.setState({
      copyPixId,
      copyId: null,
    });
  };

  getStatusColor = (status: ModalStatus): string => {
    if (status === 'Pago') return '#75B943';
    if (status === 'Vencido') return '#e34e2a';
    if (status === 'A vencer') return '#f0b01b';
    return '#000';
  };

  render(): JSX.Element {
    const { close, back, setCloseModal, showMobileMode, payment } = this.props;
    const {
      installment,
      customer,
      invoice,
      copyId,
      copyPixId,
      qrCodeDataState,
      status,
    } = this.state;

    const typeableLine = installment.typeableLine ?? '';
    const pixEmv = qrCodeDataState?.emv ?? '';

    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton title="Fechar" className="mdi mdi-arrow-left" />
            ) : null}
            <Title>Detalhes da cobrança</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <CustomerInfoContainer>
            <Info>
              <InfoTitle>Cliente:</InfoTitle>
              <InfoText>{customer.name}</InfoText>
            </Info>
            <Info $spaced>
              <InfoTitle>Endereço:</InfoTitle>
              <InfoText>
                {`${customer.address ?? ''}, ${
                  customer.addressNumber ?? ''
                } - ${customer.county ?? ''} - ${customer.city ?? ''} - ${
                  customer.stateCode ?? ''
                }`}
              </InfoText>
            </Info>
          </CustomerInfoContainer>
          <Hr />
          <DetailsContainer>
            <SectionTitle>Detalhes</SectionTitle>
            <DetailsContent>
              <Info>
                <InfoTitle>Número da Nota:</InfoTitle>
                <Link
                  to={`/notas?invoice-number=${payment.invoiceNumber ?? ''}`}
                >
                  <InvoiceNumber>{invoice.invoiceNumber}</InvoiceNumber>
                </Link>
              </Info>
              <Info>
                <InfoTitle>Vencimento:</InfoTitle>
                <InfoText>
                  {installment.dueDate
                    ? moment(installment.dueDate).format('DD/MM/YYYY')
                    : '-'}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Valor:</InfoTitle>
                <InfoText>
                  <Currency
                    quantity={installment.amountOriginal ?? 0}
                    currency="BRL"
                    locale="pt"
                  />
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Status:</InfoTitle>
                <StatusContainer>
                  <StatusIcon $color={this.getStatusColor(status)} />
                  <StatusText>{status}</StatusText>
                </StatusContainer>
              </Info>
            </DetailsContent>
            {installment.paymentTypeBoleto && status !== 'Pago' ? (
              <>
                <Hr />
                <BankSlipContainer>
                  <PaymentWrap>
                    <PaymentInfos>
                      <SectionTitle>Boleto de Cobrança</SectionTitle>
                      <Info $spaced>
                        <InfoTitle>Linha Digitável:</InfoTitle>
                        <TypeableLineContainer>
                          <InfoText>{typeableLine}</InfoText>
                          <CopyToClipboard text={typeableLine}>
                            <ToolTipButton
                              onClick={() =>
                                this.handleCopyToClickBoard(typeableLine)
                              }
                              data-tip
                              data-for="copy"
                            >
                              <TypeableLineIcon className="mdi mdi-content-copy" />
                            </ToolTipButton>
                          </CopyToClipboard>
                          <ReactTooltip
                            id="copy"
                            place="right"
                            effect="solid"
                            type="info"
                          >
                            <ToolTipText>
                              {copyId === typeableLine && copyPixId === null
                                ? 'Copiado'
                                : 'Clique para copiar'}
                            </ToolTipText>
                          </ReactTooltip>
                        </TypeableLineContainer>
                      </Info>
                      <BarcodeContainer className="mt-2">
                        <Info>
                          <InfoTitle>Código de Barras:</InfoTitle>
                          <BarcodeContent>
                            <BarcodeFullWidth>
                              <Barcode
                                format="ITF"
                                displayValue={false}
                                width={1}
                                height={70}
                                background="#ffffff"
                                value={this.convertLine(typeableLine)}
                              />
                            </BarcodeFullWidth>
                          </BarcodeContent>
                          <BarcodeResponsive>
                            <Barcode
                              format="ITF"
                              displayValue={false}
                              width={0.6}
                              height={70}
                              background="#ffffff"
                              value={this.convertLine(typeableLine)}
                            />
                          </BarcodeResponsive>
                        </Info>
                      </BarcodeContainer>
                    </PaymentInfos>
                    {pixEmv && (
                      <PaymentInfos>
                        <UpdatePixContainer>
                          <SectionTitle>Pague com PIX</SectionTitle>
                          {!showMobileMode && (
                            <CustomToolip
                              title="Já efetuou o pagamento?"
                              componentShow={() => (
                                <span>
                                  Clique aqui para atualizar o status do boleto
                                </span>
                              )}
                            >
                              <PixSyncIcon
                                size={22}
                                onClick={() => setCloseModal?.(true)}
                              />
                            </CustomToolip>
                          )}
                          {showMobileMode && (
                            <PixSyncIcon
                              size={22}
                              onClick={() => setCloseModal?.(true)}
                            />
                          )}
                        </UpdatePixContainer>
                        {showMobileMode && (
                          <MobileInfoTooltipWrap>
                            <MobileInfoTooltipContainer>
                              <MobileInfoTooltipTitle>
                                Já efetuou o pagamento?
                              </MobileInfoTooltipTitle>
                              <MobileInfoTooltipText>
                                <span>Clique em</span>
                                <span>
                                  <PixSyncIcon size={18} />
                                </span>
                                <span>para atualizar o status do boleto</span>
                              </MobileInfoTooltipText>
                            </MobileInfoTooltipContainer>
                          </MobileInfoTooltipWrap>
                        )}
                        <Info $spaced>
                          <InfoTitle>Código Copia e Cola</InfoTitle>
                          <TypeableLineContainer>
                            <InfoTextPix>{pixEmv}</InfoTextPix>
                            <CopyToClipboard text={pixEmv}>
                              <ToolTipButton
                                onClick={() =>
                                  this.handleCopyPixToClickBoard(pixEmv)
                                }
                                data-tip
                                data-for="copy-pix"
                              >
                                <TypeableLineIcon className="mdi mdi-content-copy" />
                              </ToolTipButton>
                            </CopyToClipboard>
                            <ReactTooltipPix
                              id="copy-pix"
                              place="right"
                              effect="solid"
                              type="info"
                            >
                              <ToolTipText>
                                {copyPixId === pixEmv && copyId === null
                                  ? 'Copiado'
                                  : 'Clique para copiar'}
                              </ToolTipText>
                            </ReactTooltipPix>
                          </TypeableLineContainer>
                        </Info>
                        <BarcodeContainer className="mt-2">
                          <Info>
                            <InfoTitle>QR Code:</InfoTitle>
                            <BarcodeContent>
                              <PixCode size={90} value={pixEmv} />
                            </BarcodeContent>
                            <BarcodeResponsive>
                              <PixCode size={90} value={pixEmv} />
                            </BarcodeResponsive>
                          </Info>
                        </BarcodeContainer>
                      </PaymentInfos>
                    )}
                  </PaymentWrap>
                </BankSlipContainer>
              </>
            ) : (
              <RemoveSpace />
            )}
          </DetailsContainer>
        </Content>
      </Container>
    );
  }
}

export default connect()(BankSlipModal);
